import type { TypographyProps } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { getCollapsedMaxHeightPx } from "./getCollapsedMaxHeightPx";

interface ICollapsedTextContentProps extends TypographyProps {
  expanded: boolean;
  maxCollapsedLine: number;
  maxCollapsedHeightPx?: number;
}

export const Root = styled(Stack)({
  alignItems: "flex-start",
  maxWidth: "100%",
  width: "100%",
});

export const ExpandButton = styled("span")(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.info.main,
  cursor: "pointer",
  fontWeight: 600,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  userSelect: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const CollapsedTextContent = styled(Typography, {
  shouldForwardProp: (prop) =>
    prop !== "expanded" &&
    prop !== "maxCollapsedLine" &&
    prop !== "maxCollapsedHeightPx",
})<ICollapsedTextContentProps>(({
  theme,
  expanded,
  maxCollapsedLine,
  maxCollapsedHeightPx,
  variant = "caption",
}) => {
  const collapsedHeightPx =
    maxCollapsedHeightPx ??
    getCollapsedMaxHeightPx(theme, variant, maxCollapsedLine);

  return {
    width: "100%",
    maxWidth: "100%",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    ...(expanded
      ? {}
      : {
          overflow: "hidden",
          maxHeight: `${collapsedHeightPx}px`,
        }),
  };
});
